import * as React from 'react'

import { DaysOfWeekIcon, Strong, Text } from 'main/ui'
import { formatDaysOfWeek } from 'main/util/profile'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'

const PRE = `${i18nKeyPrefix}-BASICS-DAYS-OF-WEEK`

interface IProps {
  daysOfWeek: boolean[]
}

export default function DaysOfWeek(props: IProps) {
  const { daysOfWeek } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Bullet icon={<DaysOfWeekIcon />}>
      <Strong>{t(`${PRE}-TEXT`)}</Strong>
      <Text muted>{formatDaysOfWeek(daysOfWeek)}</Text>
    </Bullet>
  )
}
